import { useMemo } from 'react';
import { MarkdownContent } from '@reflex/ui/components/content/MarkdownContent';
import type { TextBlock } from '../types.js';
import { rendersNothing } from './block-visibility.js';

/** If the entire text is a JSON object/array, return it pretty-printed; otherwise null. */
function tryPrettyJson(text: string): string | null {
  const trimmed = text.trim();
  if (!(trimmed.startsWith('{') || trimmed.startsWith('['))) return null;
  try {
    const parsed = JSON.parse(trimmed);
    return JSON.stringify(parsed, null, 2);
  } catch {
    return null;
  }
}

export function TextBlockView({ block, showCursor }: { block: TextBlock; showCursor?: boolean }) {
  const prettyJson = useMemo(() => (block.text ? tryPrettyJson(block.text) : null), [block.text]);

  if (rendersNothing(block) && !showCursor) return null;

  const renderedContent = prettyJson ? `\`\`\`json\n${prettyJson}\n\`\`\`` : block.text;

  return (
    <div className="relative">
      {block.text && <MarkdownContent content={renderedContent} size="sm" trailingScanners />}
      {showCursor && (
        <span className="ml-0.5 inline-block h-4 w-[2px] animate-pulse bg-foreground/70 align-text-bottom" />
      )}
    </div>
  );
}
